<template>
  <div id="inventory-wrapper">
    <nav-bar class="nav-bar" :current-page="'INVENTORY'" style="top: 0"></nav-bar>
    <div class="project-list-w">
      <div class="project-list">
        <div class="section-title">Inventory</div>
        <div class="no-project">
        <div>
          <img src="../assets/wrench.svg" alt="under construction status" width="36%" style="margin-bottom: 12px">
          <div>
            Under Construction
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '../components/NavBar.vue'

export default {
  name: 'Inventory',
  components: { NavBar }
}
</script>

<style>
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  transition: top 0.3s;
}
</style>
